<template>
  <div>
    <Row :gutter="16">
      <Col :span="8">
        <!-- <Affix :offset-top="123"> -->
        <Card>
          <p slot="title">操作</p>
          <div>
            <Form ref="formInline" :model="formInline" :rules="ruleInline">
              <Form-item prop="parentId" label="父级">
                <!-- <Select v-model="formInline.parentId" clearable>
                  <Option v-for="item in data" :value="item.id" :key="item.id">
                    {{ item.name }}
                  </Option>
                </Select> -->
                <Cascader
                  :data="treeData"
                  v-model="parentIds"
                  clearable
                  change-on-select
                  @on-change="resourceTypeChange"
                ></Cascader>
              </Form-item>
              <Form-item prop="name" label="类型名称">
                <Input
                  type="text"
                  v-model="formInline.name"
                  clearable
                  placeholder="类型名称"
                ></Input>
              </Form-item>
              <Form-item>
                <Button
                  type="success"
                  icon="ios-plus-empty"
                  shape="circle"
                  @click="handleAdd('formInline')"
                  long
                >
                  在父级下添加
                  {{ formInline.name }} 子级
                </Button>
              </Form-item>
              <Form-item>
                <Button
                  type="primary"
                  icon="ios-compose"
                  shape="circle"
                  @click="handleUpdate('formInline')"
                  long
                >
                  修改类型名称
                </Button>
              </Form-item>
              <Form-item>
                <Button
                  type="error"
                  icon="ios-trash-outline"
                  shape="circle"
                  @click="handleDelete('formInline')"
                  long
                >
                  删除类型
                </Button>
              </Form-item>
            </Form>
          </div>
        </Card>
        <!-- </Affix> -->
      </Col>
      <Col :span="16">
        <Card>
          <p slot="title">全部</p>
          <div>
            <Tree :data="treeData" @on-select-change="selectChange"></Tree>
          </div>
        </Card>
      </Col>
    </Row>
  </div>
</template>
<script>
  import apiResource from "@/api/resource.js";
  import { toTree, findPathbyId } from "@/libs/tools";
  export default {
    data() {
      return {
        parentIds: [],
        formInline: { parentId: "", name: "", id: 0 },
        data: [],
        ruleInline: {
          name: [
            {
              required: true,
              trigger: "change",
            },
          ],
        },
        treeData: [],
      };
    },
    methods: {
      getData() {
        let _this = this;
        apiResource
          .listResourceType({})
          .then((res) => {
            _this.data = res.data;
            _this.treeData = toTree(res.data);
            //_this.data.unshift({ id: "", name: "--顶级--" });
          })
          .catch((err) => {
            if (err.response.data.message)
              _this.$Message.error(err.response.data.message);
            else _this.$Message.error(JSON.stringify(err.response.data));
          });
      },
      selectChange(arr, item) {
        this.formInline.name = item.name;
        this.formInline.id = item.id;

        if (item.parentId) {
          this.formInline.parentId = item.parentId;
          let ids = findPathbyId(this.treeData, item.parentId);
          this.parentIds = ids.map((x) => x.id);
        } else {
          this.formInline.parentId = 0;
          this.parentIds = [];
        }
      },
      handleAdd(formName) {
        let _this = this;

        this.$refs[formName].validate((valid) => {
          if (valid) {
            apiResource
              .addResourceType(this.formInline)
              .then((res) => {
                _this.$Message.success(res.data.message);
                _this.getData();
              })
              .catch((err) => {
                if (err.response.data.message)
                  _this.$Message.error(err.response.data.message);
                else _this.$Message.error(JSON.stringify(err.response.data));
              });
          }
        });
      },
      handleUpdate(formName) {
        let _this = this;

        if (!this.formInline.id) {
          _this.$Message.warning("请在右侧选中需要修改的类型");
          return;
        }

        this.$refs[formName].validate((valid) => {
          if (valid) {
            apiResource
              .updateResourceType(this.formInline)
              .then((res) => {
                _this.$Message.success(res.data.message);
                _this.getData();
              })
              .catch((err) => {
                if (err.response.data.message)
                  _this.$Message.error(err.response.data.message);
                else _this.$Message.error(JSON.stringify(err.response.data));
              });
          }
        });
      },
      handleDelete() {
        let _this = this;

        if (!this.formInline.id) {
          _this.$Message.warning("请在右侧选中需要删除的类型");
          return;
        }
        this.$Modal.confirm({
          title: "您确定删除这条数据吗？",
          content: _this.formInline.name,
          onOk: () => {
            apiResource
              .deleteResourceType(_this.formInline.id)
              .then((res) => {
                _this.$Message.success(res.data.message);
                _this.formInline.id = 0;
                _this.getData();
              })
              .catch((err) => {
                if (err.response.data.message)
                  _this.$Message.error(err.response.data.message);
                else _this.$Message.error(JSON.stringify(err.response.data));
              });
          },
          onCancel: () => {
            //this.$Message.info('点击了取消');
          },
        });
      },
      resourceTypeChange(values, selectedDatas) {
        if (values && values.length > 0) {
          this.formInline.parentId = values[values.length - 1];
        } else {
          this.formInline.parentId = 0;
        }
      },
    },
    mounted() {
      this.getData();
    },
  };
</script>
